import { Button } from "@fluentui/react-components";
import { FluentIcon } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";

import { useAppTheme } from "hooks/useAppTheme";
import useNotificationHandler from "hooks/useNotificationHandler";

import { INotification } from "../../library/types";
import { StyledTooltip } from "../styled";

type Props = {
  icon: FluentIcon;
  label: string;
  link?: string;
  isLoading?: boolean;
  /** The page-guide anchor (`help/`); pass it through `helpAnchor()` at the call site. */
  dataHelp?: string;
};

export const DocumentLinkButton = ({ icon: Icon, label, link, isLoading, dataHelp }: Props) => {
  const { t } = useTranslation();
  const theme = useAppTheme();
  const { handleAddNotification } = useNotificationHandler();

  return (
    <StyledTooltip content={label} relationship="label">
      <Button
        size="large"
        appearance="transparent"
        data-help={dataHelp}
        disabled={isLoading}
        icon={<Icon fontSize={25} />}
        style={{
          color: theme.palette.purpleDark,
          minWidth: "fit-content",
        }}
        onClick={() => {
          if (!link) {
            handleAddNotification({
              id: Date.now().toString(),
              text: t("hbh.documentNotAvailable.label", { document: label }),
              type: "error",
            } as INotification);
            return;
          }
          window.open(link, "_blank", "noopener,noreferrer");
        }}
      />
    </StyledTooltip>
  );
};
